<template>
    <div class="box box-static-study">
        <static-study-file style="height:100%"
            label="Livrable de l'étude"
            :parent_data="active_study"
            file_property="pdfLien"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import StaticStudyFile from "@/components/study/static-study/static-study-file";

export default {
	name: "static-study",
	data: function () {
		return {
			more_menu: false,
			show_switcher_info: false,
		};
	},
	computed: {
		...mapGetters(["active_study"]),
	},
	components: { StaticStudyFile },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'
@import '../../assets/css/grid'

.box.box-static-study
    background-color white
    height 100%
    margin 5%
</style>
